import { render, staticRenderFns } from "./DialogUpdateTaxDate.vue?vue&type=template&id=630c985c"
import script from "./DialogUpdateTaxDate.vue?vue&type=script&lang=js"
export * from "./DialogUpdateTaxDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports